<template>
  <div>
    <avue-crud
      :option="taskTableOption"
      :data="taskTableData"
      :page.sync="page"
      :search.sync="searchForm"
      @size-change="sizeChange"
      @current-change="currentChange"
      @search-change="searchChange"
      ref="crud"
      highlight-current
    >
      <template slot-scope="scope" slot="status">
        <span>{{ $taskStatus.get(scope.row.status) }}</span>
      </template>

      <template slot-scope="scope" slot="taskType">
        <span>{{ $actionType.get(scope.row.taskType) }}</span>
      </template>

      <template slot="receiveTime" slot-scope="scope">
        <span>{{ formatDate(scope.row.receiveTime) }}</span>
      </template>
      <template slot-scope="scope" slot="amount">
        <el-badge
          v-if="scope.row.status === 1 && scope.row.addAmount"
          :value="'+' + scope.row.addAmount"
          class="item"
        >
          <span style="padding-right: 5px">{{ scope.row.amount }}</span>
        </el-badge>
        <span v-else>{{ scope.row.amount }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="menu">
        <el-button
          type="success"
          icon="el-icon-document"
          size="mini"
          plain
          @click.stop="viewDetail(row, index)"
        >
          查看详情
        </el-button>
        <el-button
          type="success"
          v-if="row.status === 1 && permissions.dot_repush"
          style="margin-left: 0"
          icon="el-icon-document"
          size="mini"
          plain
          @click.stop="rePushSingle(row)"
        >
          重新推送
        </el-button>
      </template>
    </avue-crud>

    <el-drawer
      title="句子详情"
      :visible.sync="drawer"
      direction="ltr"
      size="75%"
      :before-close="handleClose"
    >
      <el-badge
        v-if="drawerAddAmt && drawerStatus === 1"
        :value="'+' + drawerAddAmt"
        class="item"
      >
        <p class="note" style="padding-right: 5px">
          任务金额: ￥{{ this.drawerAmt }}
        </p>
      </el-badge>
      <p class="note" v-else>任务金额: ￥{{ this.drawerAmt }}</p>
      <avue-crud :option="taskDetailOption" :data="taskDetailData">
        <template slot-scope="scope" slot="srcText">
          <rich-text :jsonText="scope.row.srcText" readonly />
        </template>
        <template slot-scope="scope" slot="peText">
          <rich-text :jsonText="scope.row.peText" readonly />
        </template>
        <template slot-scope="scope" slot="auditResult">
          <span>{{ $auditResult.get(scope.row.auditResult) }}</span>
        </template>
      </avue-crud>
    </el-drawer>
  </div>
</template>

<script>
import { taskTableOption, taskDetailOption } from '@/const/crud/dot/pe';
import { pageTask, detailTask } from '@/api/dot/pe';
import { formatDate } from '@/util/date';
import { rePushSingle } from '@/api/dot/order';
import { mapGetters } from 'vuex';
import { statistics } from '../../../../api/dot/flow';
import RichText from '@/components/rich-text';

export default {
  components: {
    RichText,
  },
  props: ['flowInfo', 'staParams'],
  data() {
    return {
      taskTableOption: taskTableOption,
      taskTableData: [],
      page: {
        pageSize: 20,
        pagerCount: 5,
        currentPage: 1,
        total: 0,
      },
      searchForm: {},
      taskDetailOption: taskDetailOption,
      taskDetailData: [],
      drawer: false,
      drawerAmt: 0,
      drawerStatus: 0,
      drawerAddAmt: 0,
    };
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    formatDate(time) {
      if (time) {
        let date = new Date(parseFloat(time));
        return formatDate(date, 'yyyy-MM-dd hh:mm');
      }
    },
    rePushSingle(row) {
      //String orderId, Integer taskType, String packageNo
      rePushSingle({
        orderId: row.orderId,
        taskType: row.taskType,
        packageNo: row.packageNo,
      }).then((res) => {
        this.$message.success('推送结果：' + res.data.data);
        statistics(
          Object.assign(
            {
              event_name: '重新推送',
              event_type: 'click',
              class_name: 'rePushSingle',
              class_url: '/dotadmin/dotadmin/order/rePushSingle',
              event_params:
                '{orderId: row.orderId, taskType: row.taskType, packageNo: row.packageNo}',
            },
            this.staParams,
          ),
        );
      });
    },
    getPage: function (page, params) {
      pageTask(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          params,
          { orderId: this.flowInfo.orderId },
        ),
      ).then((response) => {
        this.taskTableData = response.data.data.records;
        this.page.total = response.data.data.total;
      });
    },
    searchChange(params, done) {
      this.searchForm = params;
      this.page.currentPage = 1;
      this.getPage(this.page, this.searchForm);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
            class_name: 'pageTask',
            class_url: '/dotadmin/dotadmin/pe/task/page',
          },
          this.staParams,
        ),
      );
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.getPage(this.page, this.searchForm);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.getPage(this.page, this.searchForm);
    },
    viewDetail(row, index) {
      this.taskDetailData = [];
      this.drawer = true;
      this.drawerStatus = row.status;
      this.drawerAddAmt = row.addAmount;
      this.drawerAmt = row.amount;
      detailTask(row.id).then((response) => {
        this.taskDetailData = response.data.data;
        statistics(
          Object.assign(
            {
              event_name: '查看详情',
              event_type: 'click',
              class_name: 'detailTask',
              class_url: '/dotadmin/dotadmin/pe/task/detail',
              event_params: '{id: row.id}',
            },
            this.staParams,
          ),
        );
      });
    },
    handleClose() {
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss">
.el-drawer {
  overflow-y: auto;

  .note {
    font-size: 14px;
    padding-left: 20px;
    margin: 0 0 20px 0;
  }
}
</style>
<style scoped>
.item {
  margin-top: 10px;
}
</style>
